export default function hasNotCompletedSetup(tokenDetails) {
    const {orgSetup, metrcSetup} = tokenDetails || '';

    return !orgSetup || !metrcSetup;
}

export function failsTokenAndSetupCheck(token, tokenDetails) {
    return !token || hasNotCompletedSetup(tokenDetails);
}